import CombinedStyleSheet from "../internal/CombinedStyleSheet";
import suffixProperties from "../internal/suffixProperties";
import systemTallWeights from "../helpers/systemTallWeights";
import human from "./human";

// https://developer.apple.com/videos/play/wwdc2016/801/

const getStylesForColor = color => {
  const colorSuffix = color === "white" ? "White" : "";
  return {
    largeTitle: {
      ...human[`largeTitle${colorSuffix}Object`],
      ...systemTallWeights.regular,
      lineHeight: '52px'
    },
    title1: {
      ...human[`title1${colorSuffix}Object`],
      ...systemTallWeights.regular,
      lineHeight: '43px'
    },
    title2: {
      ...human[`title2${colorSuffix}Object`],
      ...systemTallWeights.regular,
      lineHeight: '35px'
    },
    title3: {
      ...human[`title3${colorSuffix}Object`],
      ...systemTallWeights.regular,
      lineHeight: '32px'
    },
    headline: {
      ...human[`headline${colorSuffix}Object`],
      ...systemTallWeights.semibold,
      lineHeight: '28px'
    },
    body: {
      ...human[`body${colorSuffix}Object`],
      ...systemTallWeights.regular,
      lineHeight: '28px'
    },
    callout: {
      ...human[`callout${colorSuffix}Object`],
      ...systemTallWeights.regular,
      lineHeight: '26px'
    },
    subhead: {
      ...human[`subhead${colorSuffix}Object`],
      ...systemTallWeights.regular,
      lineHeight: '25px'
    },
    footnote: {
      ...human[`footnote${colorSuffix}Object`],
      ...systemTallWeights.regular,
      lineHeight: '23px'
    },
    caption1: {
      ...human[`caption1${colorSuffix}Object`],
      ...systemTallWeights.regular,
      lineHeight: '20px'
    },
    caption2: {
      ...human[`caption2${colorSuffix}Object`],
      ...systemTallWeights.regular,
      lineHeight: '16px'
    }
  };
};

export default CombinedStyleSheet.create({
  ...getStylesForColor("black"),
  ...suffixProperties(getStylesForColor("white"), "White")
});